<template>
	<section class="contact">
		<div class="contact-scroller scroller" :data-dir="scroller">Kontakt</div>
		<div class="contact-container">
			<h2 class="contact-title" data-anim="flip">Kontakt</h2>
			<div class="contact-data">
				<div class="contact-flex contact-address">
					<div class="contact-info">
                        Studio Wien<br>
						Kaiserstraße 89<br>
						1070 Wien<br>
					</div>
					<div class="contact-info contact-opening">
						Öffnungszeiten<br>
						<dl>
							<dt>Mo - Fr</dt>
							<dd>10:00 - 19:00</dd>
							<dt>Sa</dt>
							<dd>10:00 - 14:00</dd>
						</dl>
					</div>
				</div>
				<div class="contact-flex contact-address">
					<div class="contact-info">
                        Privatatelier<br>
						Schloss Straße 41<br>
						2551 Enzesfeld<br>
					</div>
					<div class="contact-info contact-opening">
						Terminvereinbarung<br>
                        <a href="mailto:studio@triestink.com">studio@triestink.com</a>
					</div>
				</div>
				<div class="contact-flex">
					<div class="contact-social" data-anim="slide">
						<a class="social-link" target="_blank" rel="noopener" href="https://www.instagram.com/triestink/">
							<img src="/gfx/instagram.svg" alt="Instagram">
						</a>
						<a class="social-link" target="_blank" rel="noopener" href="https://wa.me/436645642827">
							<img src="/gfx/whatsapp.svg" alt="Facebook">
						</a>
					</div>
					<div class="contact-social totop" data-anim="slide">
						<button @click="totop()" class="social-link totop-link" aria-label="Nach oben">
							<img src="/gfx/totop.svg" alt="">
						</button>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import W from '@wamms/tinylib'

	export default {
		name: 'Contact',
		props: {
			scroller: String
		},
		methods: {
			totop: function() {
				W.scroll.top()
			}
		}
	}
</script>